<template>
  <v-layout wrap ror justify-center>
    <v-flex xs12 sm10 mb6>
      <v-toolbar flat color="white">
        <v-toolbar-title>ログイン情報メンテ</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">新規追加</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.username" label="ログインID"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field type="password" v-model="editedItem.pass" label="パスワード"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-select
                      v-model="editedItem.role"
                      :items="roles"
                      box
                      label="権限"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="error" flat @click="close">キャンセル</v-btn>
              <v-btn class="success" flat @click="save">保存</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
      >
        <template v-slot:items="props">
          <td>{{ props.item.username }}</td>
          <td></td>
          <td>{{ props.item.role }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              class="mr-2"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <template v-slot:no-data>
        </template>
      </v-data-table>

      <v-snackbar
        v-model="snackbar"
        color="success"
        :timeout=2000
      >
        {{ msg }}
        <v-btn
          flat
          @click="snackbar = false"
        >
          閉じる
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import Common from '@/components/Common'
export default {
  mixins: [ Common ],
  data: () => ({
    dialog: false,
    headers: [
      { text: 'ログインID', value: 'username' },
      { text: 'パスワード', value: 'pass' },
      { text: '権限', value: 'role' },
      { text: '編集/削除', value: 'action', sortable: false }
    ],
    roles: [
      { text: '常勤用', value: 'admin' },
      { text: 'パート用', value: '' }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      username: '',
      pass: '',
      role: ''
    },
    defaultItem: {
      username: '',
      pass: '',
      role: ''
    },
    msg: '',
    snackbar: ''
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '新規追加' : '編集'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.kousin()
  },

  methods: {
    kousin () {
      var self = this
      this.$axios.post(this.url + 'login.php', JSON.stringify({
        st: 'get'
      })).then(function (res) {
        self.items = res.data
      })
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      confirm('削除してもよろしいですか？') && this.items.splice(index, 1)
      var self = this
      this.$axios.post(this.url + 'login.php', JSON.stringify({
        st: 'del',
        item: item
      })).then(function () {
        self.msg = '削除完了しました。'
        self.snackbar = true
        self.kousin()
        self.close()
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      var status = 'upd'
      if (this.editedIndex > -1) {
        status = 'upd'
      } else {
        status = 'ins'
      }
      var self = this
      this.$axios.post(this.url + 'login.php', JSON.stringify({
        st: status,
        item: this.editedItem
      })).then(function () {
        self.msg = '更新完了しました。'
        self.snackbar = true
        self.kousin()
        self.close()
      })
    }
  }
}
</script>

<style lang="stylus">
  .application {
    width 100%
  }
</style>
